import React, { Fragment } from 'react';
import PropTypes, { object } from 'prop-types';
import cn from 'classnames';

import {
  Table,
  Member,
  DateTime,
  TableCell,
  Button,
  SidebarShowError
} from 'components/common/Elements/Elements';

import AdditionalContent from '../AdditionalContent/AdditionalContent';

import classes from './PageTable.module.scss';

const TableRow = ({
  company,
  tableConf,
  row,
  mouseEnter,
  onOpenAdditionalModal
}) => {
  const createMember = company => {
    return {
      fullName: company.updatedByName,
      description: company.updatedByEmail,
      initials: company.updatedByName
        .split(' ')
        .map(x => x.charAt(0))
        .join('')
        .substr(0, 2)
        .toUpperCase()
    };
  };

  return (
    <Table.Row className={classes.row}>
      {tableConf.map(({ show, field }, ind) => {
        const cellProps = {
          row: row,
          mouseEnter: mouseEnter,
          ind: ind,
          field: field,
          classes: classes
        };

        return (
          <Fragment key={`${field}-${company.email}}`}>
            {show && field === 'featureName' && (
              <TableCell cellProps={cellProps}>
                {company.featureName ? company.featureName : 'NA'}
              </TableCell>
            )}
            {show && field === 'action' && (
              <TableCell cellProps={cellProps}>{company.action}</TableCell>
            )}
            {show && field === 'updatedByName' && (
              <TableCell
                cellProps={cellProps}
                classNameContent={classes.center}
              >
                <Member member={createMember(company)} />
              </TableCell>
            )}
            {show && field === 'status' && (
              <TableCell
                cellProps={cellProps}
                classNameContent={cn(
                  classes.center,
                  company.status === 'Success'
                    ? classes.color_success
                    : classes.color_error
                )}
              >
                {company.status === 'Success' ? (
                  company.status
                ) : company.message ? (
                  <div>
                    {'Error'}{' '}
                    <Button
                      className={classes.more}
                      onClick={() =>
                        onOpenAdditionalModal({
                          content: <SidebarShowError data={company.message} />
                        })
                      }
                    >
                      more...
                    </Button>
                  </div>
                ) : (
                  'Error'
                )}
              </TableCell>
            )}
            {show && field === 'assignedIds' && (
              <TableCell
                cellProps={cellProps}
                classNameContent={classes.center}
              >
                {company.action === 'General Availability' ? (
                  'GA'
                ) : company.assignedIds && company.assignedIds.length > 0 ? (
                  <Button
                    className={classes.btnModal}
                    onClick={() =>
                      onOpenAdditionalModal({
                        content: (
                          <AdditionalContent
                            data={company._id}
                            mode={'assign'}
                          />
                        )
                      })
                    }
                  >
                    {company.assignedIds.length}
                  </Button>
                ) : company.customerIds ? (
                  company.customerIds.length
                ) : (
                  'NA'
                )}
              </TableCell>
            )}
            {show && field === 'unassignedIds' && (
              <TableCell
                cellProps={cellProps}
                classNameContent={classes.center}
              >
                {company.unassignedIds && company.unassignedIds.length > 0 ? (
                  <Button
                    className={classes.btnModal}
                    onClick={() =>
                      onOpenAdditionalModal({
                        content: <AdditionalContent data={company._id} />
                      })
                    }
                  >
                    {company.unassignedIds.length}
                  </Button>
                ) : company.unassignedIds ? (
                  company.unassignedIds.length
                ) : (
                  'NA'
                )}
              </TableCell>
            )}
            {show && field === '_created_at' && (
              <TableCell
                cellProps={cellProps}
                classNameContent={classes.center}
              >
                <DateTime date={company._created_at} time />
              </TableCell>
            )}
          </Fragment>
        );
      })}
    </Table.Row>
  );
};

TableRow.propTypes = {
  company: PropTypes.object,
  tableConf: PropTypes.arrayOf(object),
  row: PropTypes.string,
  mouseEnter: PropTypes.func,
  handleCheckCustomer: PropTypes.func,
  CheckBox: PropTypes.func,
  onOpenAdditionalModal: PropTypes.func.isRequired
};

export default TableRow;
